import AxiosInstance from '../config/AxiosInstance';
import AxiosInstanceFormData from '../config/AxiosInstanceFormData';

export interface Product {
    id: string;
    sku: string;
    type: number;
    productName: string;
    productGroup: { groupName: string };
    updatedAt: Date;
    isActive: boolean;
}

export interface ProductAttributesPayload {
    productId: string;
    position: number;
}

export interface AttributesPayload {
    attributeName: string,
    displayName: string,
    type: number,
    companyId: string,
    baseAttributeId?: string | null,
    image?: string,
    /** Hex (e.g. #EBF0F0). Omitted when POS styling is not customized — POS keeps default look. */
    backgroundColor?: string,
    /** Hex (e.g. #05292A). Omitted when POS styling is not customized. */
    fontColor?: string,
    items: ProductAttributesPayload[]
}

const createAttributes = async (payload: FormData) => {
    try {
        const { data } = await AxiosInstanceFormData.post('/api/inventory/attributes', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailAttributes = async (id: string, companyId: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/attributes/find-one/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateAttributes = async (id: string, payload: FormData) => {
    try {
        const { data } = await AxiosInstanceFormData.put('/api/inventory/attributes/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListAttributes = async (companyId: string, page: number, limit: number, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/attributes/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListSubAttributes = async (
    companyId: string,
    page: number,
    limit: number,
    searchValue: string,
    baseAttributeId: string | null
) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/attributes/list-base', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
                baseAttributeId: baseAttributeId
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteAttribute = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/inventory/attributes/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    createAttributes,
    updateAttributes,
    getListAttributes,
    getListSubAttributes,
    deleteAttribute,
    getDetailAttributes
}